import React, { Component, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTable, usePagination } from 'react-table';
import { Modal } from "react-bootstrap";
import { apibaseURL } from "../../../../config";
import { fetchDocketData, findDockets } from '../../../../actions/docketAction';
import { mediaPath } from "../../../../config";
import { Link, NavLink, withRouter } from "react-router-dom";
import { history } from "../../../../services/helper/Helper";


class DisplayDockets extends Component {
  constructor(props) {
    super(props);
	
    this.state = {
      data: [], // Data will come from the server
      searchTerm: '', // State for search term
      columns: [
        { Header: 'Docket #', accessor: 'caseid' },
        { Header: 'Petitioner', accessor: 'petitionerFullName' },
        { Header: 'Respondent', accessor: 'respondentFullName' },
        { Header: 'Status', accessor: 'docketstatus' },
        { Header: 'Hearing Date', accessor: 'hearingdate' },
        { Header: 'Date Received', accessor: 'datereceivedbyOSAH' },
        { Header: 'eService', accessor: 'opt-in', disableSort: true },
        { Header: '', accessor: '', disableSort: true },
      ],
      pageSize: 10,
      pageIndex: 0,
      totalRecords: 0,
	  sortField: 'caseid', // Default sort field
      sortDirection: 'asc', // Default sort direction
    };

    this.debounceTimeout = null; // To store the debounce timeout reference
  }
  

  componentDidMount() {
	const { status } = this.props.match.params;
    this.fetchData();
  }
  componentDidUpdate(prevProps) {
    // Check if the 'status' parameter has changed
    const prevStatus = prevProps.match.params.status;
    const currentStatus = this.props.match.params.status;
    if (prevStatus !== currentStatus) {
      this.setState({ 
		pageIndex : 0,
		pageSize : 10,
		searchTerm : '',
		sortField : this.state.sortField,
		sortDirection : this.state.sortDirection,
	 });
      this.fetchData();
    }
 }

  fetchData = async (
	pageIndex = 0,
	pageSize = 10,
	searchTerm = '',
	sortField = this.state.sortField,
	sortDirection = this.state.sortDirection,
	status = this.props.match.params.status
  ) => {
	
    this.setState({ isLoading: true });
	try {
	  const response = await fetch(
		`${apibaseURL}getMydockets?page=${pageIndex + 1}&limit=${pageSize}&searchValue=${searchTerm}&sortName=${sortField}&sortOrder=${sortDirection}&status=${status}`
	  );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      const docketData = result.data || [];
      const totalRecords = result.dataTotalSize || 0;
      // Format data for table display
      const formattedData = docketData.map(item => ({
        caseid: (
          <NavLink to={`/publicAccess/docketInfo/${btoa(item.caseid)}`} exact>
            {item.caseid}
          </NavLink>
        ),
        petitionerFullName: item.petitionerFullName || item.petitioner || 'No Party Added',
        respondentFullName: item.respondentFullName || item.respondent || 'No Party Added',
        docketstatus: item.status,
        hearingdate: item.hearingdate,
        datereceivedbyOSAH: item.datereceivedbyOSAH,
        'opt-in': item.e_services == 1 || item.e_services == '1' ? (
          <div className="optedtooltip-block">
            <div className="optedin">
              <i className="fa fa-check-circle" aria-hidden="true"></i> <span>Opted-In</span>
            </div>
            <span className="tooltiptext">
              You have opted to be served electronically via ePortal in this case.
            </span>
          </div>
        ) : (
          <div className="optedtooltip-block">
            <div className="optedout">
              <i className="fa fa-pause" aria-hidden="true"></i> <span>Opted-Out</span>
            </div>
            <span className="tooltiptext">
              You have not opted to be served electronically via ePortal in this case.
            </span>
          </div>
        ),
        '': (
          <NavLink to={`/publicAccess/docketInfo/${btoa(item.caseid)}`} exact>
            <button className="btn btn-primary">View</button>
          </NavLink>
        ),
      }));

      this.setState({
        data: formattedData,
        totalRecords: totalRecords,
		isLoading: false,
      });
    } catch (error) {
      console.error('Error fetching data: ', error);
	  this.setState({ isLoading: false });
    }
  };

  handlePageSizeChange = (event) => {
    this.setState(
      {
        pageSize: Number(event.target.value),
        pageIndex: 0, // Reset to the first page
      },
      () => this.fetchData(this.state.pageIndex, this.state.pageSize, this.state.searchTerm)
    );
  };

  handlePageChange = (pageNumber) => {
    this.setState(
      {
        pageIndex: pageNumber,
      },
      () => this.fetchData(this.state.pageIndex, this.state.pageSize, this.state.searchTerm)
    );
  };

  // Handle search input change with debounce
  handleSearchChange = (event) => {
    const value = event.target.value;
    this.setState({ searchTerm: value });

    // Clear previous debounce timeout
    clearTimeout(this.debounceTimeout);

    // Set new debounce timeout
    this.debounceTimeout = setTimeout(() => {
      this.fetchData(this.state.pageIndex, this.state.pageSize, value); // Fetch data with search term after debounce
    }, 500); // Debounce delay
  };

  handleSortChange = (field) => {
    const { sortField, sortDirection } = this.state;
    const newSortDirection = sortField === field && sortDirection === 'asc' ? 'desc' : 'asc';

    this.setState({ sortField: field, sortDirection: newSortDirection }, () => {
      this.fetchData(this.state.pageIndex, this.state.pageSize, this.state.searchTerm);
    });
  };

  getPageNumbersToDisplay = () => {
    const { pageIndex, totalRecords, pageSize } = this.state;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const pageNumbers = [];
    
    // Show 5 page numbers with some logic
    for (let i = Math.max(0, pageIndex - 2); i <= Math.min(pageIndex + 2, totalPages - 1); i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  render() {
    const { data, columns, pageSize, pageIndex, totalRecords, isLoading, sortField, sortDirection } = this.state;

    const startRow = totalRecords === 0 ? 0 : pageIndex * pageSize + 1;
    const endRow = totalRecords === 0 ? 0 : Math.min(startRow + pageSize - 1, totalRecords);
    const pageOptions = totalRecords === 0 ? [] : Array.from({ length: Math.ceil(totalRecords / pageSize) }, (_, i) => i);

    const pageNumbersToDisplay = this.getPageNumbersToDisplay();

    return (
      <>
		{/* Loader */}
		{/* {isLoading && <div className="loader">Loading...</div>} */}
        {/* Search Input */}
        <div>
        <div class="tableTopSection">
          <div>
            {/* Showing Results */}
            <div class="NoOfResults">
              {totalRecords > 0 && (
                <div>
                  Showing {startRow} to {endRow} of {totalRecords} Results
                </div>
              )}
            </div>

            {/* Entries Per Page */}
            <div class="NoOfPages">
              <label>
                Entries per page:{" "}
                <select value={pageSize} onChange={this.handlePageSizeChange}>
                  {/* <option value={1}>1</option> */}
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </label>
            </div>
          </div>
          <div class="SearchBox">
            <label>
              <input
                type="text"
                value={this.state.searchTerm}
                onChange={this.handleSearchChange}
                placeholder="Search"
              />
            </label>
          </div>
        </div>

        {/* Table */}
        <div class="tablesection">
          <table>
            <thead>
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.accessor}
                    onClick={() => !column.disableSort && column.accessor && this.handleSortChange(column.accessor)}
                    style={{
                      cursor: column.disableSort || !column.accessor ? 'default' : 'pointer',
                      textDecoration: column.accessor === sortField && !column.disableSort ? 'underline' : 'none',
                    }}
                  >
                    {column.Header}{' '}
                    {column.accessor === sortField && !column.disableSort ? (sortDirection === 'asc' ? <i className="fa fa-angle-up" aria-hidden="true"></i> : <i className="fa fa-angle-down" aria-hidden="true"></i>) : ''}
					{column.accessor != sortField && !column.disableSort ? <i className="fa fa-angle-down" aria-hidden="true"></i> : ''}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} style={{ textAlign: 'center' }}>No results found</td>
                </tr>
              ) : (
                data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((column) => (
                      <td key={column.accessor}>{row[column.accessor]}</td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        </div>

        {/* Pagination Controls */}
        <div class="tableBottomSection">
          {totalRecords > 0 && (
            <span class="countOfPage">
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>
            </span>
          )}
          {totalRecords > 0 && (
            <div class="paginationSection">
              {/* First and Previous Buttons */}
              <button
                onClick={() => this.handlePageChange(0)}
                disabled={pageIndex === 0}
              >
                First
              </button>
              <button
                onClick={() => this.handlePageChange(pageIndex - 1)}
                disabled={pageIndex === 0}
              >
                Prev
              </button>

              {/* Page Number Links */}
              {pageNumbersToDisplay.map((pageNumber) => (
                <button
                  key={pageNumber}
                  onClick={() => this.handlePageChange(pageNumber)}
                  style={{
                    backgroundColor:
                      pageIndex === pageNumber ? "#737c8c" : "#fff",
                    color: pageIndex === pageNumber ? "#fff" : "#737c8c",
                  }}
                >
                  {pageNumber + 1}
                </button>
              ))}

              {/* Next and Last Buttons */}
              <button
                onClick={() => this.handlePageChange(pageIndex + 1)}
                disabled={pageIndex === pageOptions.length - 1}
                style={{ display: pageIndex === pageOptions.length - 1 ? 'none' : 'inline-block' }}
              >
                Next
              </button>
              <button
                onClick={() => this.handlePageChange(pageOptions.length - 1)}
                disabled={pageIndex === pageOptions.length - 1}
                style={{ display: pageIndex === pageOptions.length - 1 ? 'none' : 'inline-block' }}
              >
                Last
              </button>
            </div>
          )}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
	return {
		docketGeneralInfo: state.docketGeneralInfo,
	};
}

export default withRouter(connect(mapStateToProps, { fetchDocketData,findDockets })(DisplayDockets));